<template>
  <div class="manufacturer-search-page">
    <h2>Manufacturer Search</h2>
    <hr>
    <div class="full-screen-table-manufacturer">
      <BasicDataGrid
      :dataSource="dataSource"
      :dataGridKey="dataGridKey"
      :columns="columns"
      :actions="actions"
      :searchEntireGrid="false"
      v-on:editManufacturer="routeToManufacturer($event)"
      :showColumnLines="true" />
    </div>
  </div>
</template>
<script>
import BasicDataGrid       from '../../../components/BasicDataGrid.vue';

import { ManufacturerService } from '@/services';
import {getKeyByValue, userRoleEnum } from '../../../modules/helpers'
import { can }             from '@/permissions.js'
import { mapState } from 'vuex';

// import { getDataSource }    from "../../../modules/helpers.js";
// let manufacturers = getDataSource('Manufacturers')

export default {
  name: 'ManufacturerSearch',
  components: {
    BasicDataGrid,
  },
  data() {
    return {
      dataGridKey: 'Id',
      manufacturers: [],
      smartCatalogManufacturers: [],
      showSmartCatalogManufacturers: true,
      DMcolumns: [
        { text: 'Code' , value: 'CompanyCode'},
        { text: 'Name' , value: 'CompanyName'},
        { text: 'Phone', value: 'Phone'},
        { text: 'Fax'  , value: 'Fax'},
        { text: 'Address',
          value: 'Address',
          width: '800px',
          customizeText: (cellInfo) => {
              return this.getCompleteAddress(cellInfo.value);
          }
        },        
      ],
      SCMcolumns: [
        { text: 'Code' , value: 'DCCode'},
        { text: 'Name' , value: 'CompanyName', sortOrder: 'asc'},
        { text: 'Status', value: 'Status'},
        { text: 'Effective To'  , value: 'EffectiveTo', dataType: 'date'},
               
        // { text: 'Address',
        //   value: 'Address',
        //   customizeText: (cellInfo) => {
        //       return this.getCompleteAddress(cellInfo.value);
        //   }
        // },        
      ],
    };
  },
  computed: {
    ...mapState(['currentUser']),
     actions(){
       if (!can('edit-manufacturers')) return; // guard clause
       return [
         {
           hint: 'Edit',
           icon: 'edit',
           emit: 'editManufacturer',
         },
       ];
     },
     columns(){
       return this.showSmartCatalogManufacturers ? this.SCMcolumns : this.DMcolumns;
     },
     dataSource(){
       return this.showSmartCatalogManufacturers ? this.smartCatalogManufacturers : this.manufacturers;
     }
  },
  methods: {
    routeToManufacturer(e){
       let manufacturerId = e.row.data.Id;
       if (this.showSmartCatalogManufacturers){
         this.$router.push({ name: 'SmartCatalogManufacturerEdit', params: { id: manufacturerId } } );
       } else {
         this.$router.push({ name: 'ManufacturerEdit', params: { id: manufacturerId } } );
       }
       
    },
    getCompleteAddress(value){
      if(!value) return '';
      let completeAddress = [value.Line1, value.Line2, value.City, value.StateCode].join(', ');
      completeAddress = [completeAddress, value.ZipCode].join(' ').replace(", ,",",");;
      return completeAddress;
    },
    getManufacturers(){
      this.manufacturers = ManufacturerService.getDataSource(this.dataGridKey);
    },
    getSmartCatalogManufacturers(){
      this.smartCatalogManufacturers = ManufacturerService.getDataSourceSmartCatManufacturers(this.dataGridKey)
    }
  },
  created(){
    //console.log('currentUser', this.currentUser)
    this.showSmartCatalogManufacturers = getKeyByValue( userRoleEnum, this.currentUser.UserRoleId ) === "SmartSales Admin";
    this.getManufacturers();
    this.getSmartCatalogManufacturers();
  }
};
</script>
<style lang="scss" scoped>
  .manufacturer-search-page{
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
